import React from 'react';
import StatusMenu from '../StatusMenu';
import block from 'bem-cn-lite';
import store from '../state';
import { I18n } from 'react-i18next';

block.setup({
    mod: '--',
});

class Statebar extends React.Component {
    constructor(props) {
        super(props);

        this.onStatusChange = this.onStatusChange.bind(this)
    }

    onStatusChange(id) {
        if(!this.props.disabled) this.props.onStatusChange(id)
        return false;
    }

    render() {
        const b = block('Statebar');
        
        return (
            <I18n ns={ ['customWorkflow'] }>
            {
                (t) => (
                    <div className={b()}>
                        <div className={b('left')}>
                            <div className={b('status-menu')}>
                                <StatusMenu status={this.props.status} disabled={this.props.disabled} onStatusChange={this.onStatusChange} />
                            </div>

                            <div className={b('assignees')}>
                                <div className={b('assignee')}>
                                    <div className={b('assignee-avatar')}>
                                        <div className={b('default-avatar', { vivid: this.props.avatarColor != null })} style={{backgroundColor: this.props.avatarColor}}>{this.props.initials}</div>
                                    </div>
                                    <div className={b('assignee-name', { vivid: this.props.avatarColor != null })}>{this.props.assigneeName}</div>
                                </div>

                                <div className={b('add-assignee')}>
                                    <img src="https://cdn.wrike.com/image/__cdnu/icon_grey_vector_collaboration_plus.svg" alt="+" className={b('add-assignee-icon')}/>
                                </div>

                            </div>

                        </div>
                        <div className={b('right')}>
                            <div className={b('author')}>{this.props.author}</div>
                        </div>
                    </div>
                )
            }
            </I18n>
            
        )
    }
}

export default store(Statebar)